export default __webpack_public_path__ + "static/media/colorPicker.c3d06cc6.svg";